import asyncFetch from './async-fetch';
import { getBaseRequestConfig } from './baseRequestConfig';

export async function fetchDropboxRoles(dropboxId) {
    /* global API_BASE_URL */
    const url = `${API_BASE_URL}/dropboxes/${dropboxId}/roles`;

    const baseRequestConfig = getBaseRequestConfig();

    const response = await asyncFetch(url, baseRequestConfig);

    return await response.json();
}

export async function fetchRolesSelf() {
    /* global API_BASE_URL */
    const url = `${API_BASE_URL}/roles`;

    const baseRequestConfig = getBaseRequestConfig();

    const response = await asyncFetch(url, baseRequestConfig);

    return await response.json();
}


/** WEBPACK FOOTER **
 ** ./src/connectivity/api.roles.js
 **/